/* eslint-disable camelcase */
// import { LocationAPI } from '@/clients/auth/auth.api'
import * as types from '@/store/mutation-types'

export default {

}
